import { MouseEvent, ReactNode } from 'react';

import { cx } from '@libs/classnames';

import styles from './IconButton.module.css';

type Props = {
  className?: string;
  disabled?: boolean;
  preset?: 'gray' | 'transparent' | 'hollow';
  size?: '36' | '32' | '28' | '24';
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  title?: string;
  children: ReactNode;
};
export function IconButton({
  className,
  onClick,
  disabled,
  children,
  title,
  size = '32',
  preset = 'gray',
}: Props) {
  return (
    <div
      title={title}
      className={cx(
        styles.button,
        styles[preset],
        {
          [styles.disabled]: disabled,
        },
        styles[('size-' + size) as 'size-32'],
        className,
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
